import { ReactNode } from 'react';

export function renderMarkdownAsPlainText(body?: string | ReactNode) {
	if (!body) {
		return body;
	}

	// Remove titles (lines that start with #)
	const headers = body.toString().replace(/^\s*#+\s*(.*?)$/gm, '$1');

	// Remove image syntax ![...](...)
	const images = headers.replace(/!\[.*?\]\(.*?\)/g, '');

	// Remove bold text (e.g., __text__)
	const bold = images.replace(/(__)(.*?)\1/g, '$2');

	// Remove formatting characters (*, `, >, etc.)
	const plainText = bold.replace(/(\*|`|>)|^\s+|\s+$|\n/g, '');

	return plainText.trim();
}
